import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TopicWall from "./components/TopicWall";
import EvidenceSection from "./components/EvidenceSection";
import PersonIndex from "./components/PersonIndex";
import CollectionSection from "./components/CollectionSection";
import FeedSection from "./components/FeedSection";
import DiscussionSection from "./components/DiscussionSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Navbar />
      <main>
        <Hero />
        <TopicWall />
        <EvidenceSection />
        <PersonIndex />
        <CollectionSection />
        <FeedSection />
        <DiscussionSection />
      </main>
      <Footer />
    </div>
  );
}